<template>
  <default-box>
    <div class="d-flex align-items-center">
      <small-title
          class="flex-grow-1"
          no_margin
          :text="$t('dashboard.your_upcoming_vacations')"/>
      <img class="icon-30" src="/images/menu/vacation.svg" alt="vacation">
    </div>
    <hr/>
  <div class="user-upcoming-vacation ">
    <div v-if="loaded && !future_approved_vacation.length">
      <gray-text>{{ $t('dashboard.no_vacation_dates_founded') }}</gray-text>
    </div>
    <div v-else>
      <ol>
        <li v-for="vacation in future_approved_vacation">
          {{getDateFormatStrToShowLocal(vacation.date_start)}} - {{getDateFormatStrToShowLocal(vacation.date_end)}}
        </li>
      </ol>
    </div>
    <loader v-if="loading"/>
  </div>
  </default-box>
</template>

<script>

import GrayText from "../../../small_components/GrayText.vue";
import Loader from "../../../small_components/Loader.vue";
import {axiosUser} from "../../../../helpers/axios_requests";
import dateMixin, {getDateFormatStrToShow} from "../../../../mixins/dateMixin";
import DefaultBox from "../../../slots/DefaultBox.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";

export default {
  name: "UserUpcomingVacation",
  mixins: [dateMixin],
  components: {
    SmallTitle, DefaultBox,
    Loader,
    GrayText
  },
  computed: {
    get_date() {
      return new Date;
    },
    get_months() {
      return this.get_date.getMonth() + 1;
    }
  },
  data() {
    return {
      loading: false,
      loaded: false,
      future_approved_vacation: [],
    }
  },
  mounted() {
    this.fetchDailyReport()
  },
  methods: {
    fetchDailyReport() {
      this.loading = true
      axiosUser.getMyFutureVacations({
        year: this.get_date.getFullYear(),
        months: [this.get_months, this.get_months + 1]
      }).then(({data}) => {
        this.future_approved_vacation = data.future_approved_vacation || []
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
    getDateFormatStrToShowLocal(date) {
      return this.getDateFormatStrToShow(date, '.')
    }
  }
}
</script>
